import { render, staticRenderFns } from "./HeaderShop.vue?vue&type=template&id=727fafce"
import script from "./HeaderShop.vue?vue&type=script&lang=js"
export * from "./HeaderShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports